import React, { useEffect, useState } from "react";

import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../../entrypoints/theme";
import { CartProductOptions } from "./CartProductOptions";
import { CartProductQuantity } from "./CartProductQuantity";
import { calculatePrices } from 'frontend/js/helpers';

export const CartStackedProduct = ({ item, settings }) => {
  const [prices, setPrices] = useState(null);
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const showVariantOptions = false;
  const show_savings_pill = false;
  const price_style = "price b4";
  const savings_text_style = "text-xs";
  const {
    savings_badge_label,
    savings_badge_bundle_label,
    savings_badge_label_style
  } = settings?.globals?.savings_badge || {};

  if (!item) {
    return false;
  }

  const size = item.options_with_values.find(
    (option) => option.name.toLowerCase() === "fragrance",
  );

  const line_item_price = item.price / 100;
  const show_total_price = true;
  // @ts-ignore
  const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
  const currencyCode =  window.Alpine?.store('currency').getCurrencyCode();
  let totalDiscount = 0;
  if (item.discounts) {
    item.discounts.forEach((discount) => {
      totalDiscount += discount.amount;
    });
  }

  let optionsClass = "h4";
  let priceClass = "h4";

  if (isMobile) {
    optionsClass = "h6";
    priceClass = "h6";
  }

  const formatMoney = (cents) => {
    const dollars = cents / 100;
    return dollars.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };

  useEffect(() => {
    async function getPrices() {
      let pricesData = await calculatePrices(item.product);

      if (pricesData && item.selling_plan_allocation) {
        const { price, compare_at_price } = item.selling_plan_allocation;
        pricesData.productPrice = (price / 100).toFixed(2);
        pricesData.savings = price / compare_at_price * 100;
      }

      setPrices(pricesData);
    }

    getPrices();
  }, []);

  return (
    <>
      <div className="cart__item border-b-0 border-t lg:border-t-0 lg:border-b border-gray-200 last:border-b-0  w-full flex max-lg:flex-col gap-4 mb-2">
        <div className="flex gap-4 w-full">
          <a href={item.url} className="block w-[80px] lg:w-[186px]  h-[80px] lg:h-[160px] my-auto">
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-full object-contain"
              loading="lazy"
            />
          </a>

          <div className="product-details flex-col flex-1 w-full">
           
            <div className="product-details__inner h-full w-full">
              <div className={`product-details__inner-top py-3 px-2 gap-2 lg:gap-0`}>
                <div className="flex justify-between">
                  <div className="flex flex-col"> 
                    <a href={item.url} className="product-title title-1">
                      {item.product_title}
                    </a>


                    {item?.selling_plan_allocation?.selling_plan?.name && (
                      <div className="b4">
                        {item?.selling_plan_allocation?.selling_plan?.name }
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-col lg:mt-auto">
                  
                <div className="flex gap-2 items-center justify-between">
                  {(show_total_price && prices) && (
                    <div className="flex gap-2">
                      <div className={`price b4`}>
                        ${prices?.productPrice}
                      </div>

                      {!!prices?.savings &&
                        <s className={`price text-[#AAA] ${price_style}`}>
                          ${((prices?.singlePrice * prices?.quantityInBundle) / 100).toFixed(2)}
                        </s>
                      }
                    </div>
                  )}

                  {(show_savings_pill && !!prices?.savings) &&
                    <div className={`savings-badge ${savings_badge_label_style}`}>
                      <span>
                        {prices.discountType === 'bundle'
                          ? savings_badge_bundle_label
                          : savings_badge_label
                        }
                      </span>
                      <span>{Math.round(prices.savings)}%</span>
                    </div>
                  }
                </div>
                
                <div className="flex justify-between items-end mt-3 w-full gap-2">
                  {showVariantOptions && (
                    <div className={`product-options ${optionsClass} hidden lg:flex`}>
                      {CartProductOptions(item.options_with_values)}
                    </div>
                  )}

                  <div>
                    <CartProductQuantity item={item} settings={settings} />
                  </div>
                  <div
                  className="flex flex-col justify-end"
                  data-ajax-cart-request-button={`/cart/change?id=${item.key}&quantity=0`}
                >
                   <button 
                  className="remove-item b4 justify-end underline"
                  data-item-key={item.key}
                >
                  Remove
                </button>
                </div>

                  {/* <div className={`product-price hidden lg:block ${priceClass}`}>
                    <div className={"flex justify-end"}>
                      <div className={"flex flex-cols"}>
                        {!show_total_price ? (
                            <>
                              <p className={`cart__item-price font-normal`}>

                                {currencyCode}{currencySymbol + line_item_price.toFixed(0)}
                              </p>
                              {item.product?.compare_at_price > 0 && (
                                <p className={`cart__item-price--compare font-normal line-through`}>
                                  {currencyCode}{currencySymbol + item.product?.compare_at_price / 100}
                                </p>
                              )}
                            </>
                        ) : (
                            <div className={'flex flex-col text-right'}>
                              {item.product?.compare_at_price && item.discounts.length <= 0 && (
                                  <p className={`cart__item-price--compare font-normal line-through`}>
                                    {currencyCode}{currencySymbol}
                                    {
                                      ((item.product?.compare_at_price * item.quantity) / 100).toFixed(0)
                                    }
                                  </p>
                              )}
                              {!item.product?.compare_at_price && item.discounts.length > 0 && (
                                  <p className={`cart__item-price--compare font-normal line-through test2`}>
                                    {currencyCode}
                                    {currencySymbol}
                                    {(item.original_line_price  * item.quantity / 100)}
                                  </p>
                              )}

                               <p className={`cart__item-price font-normal`}>
                                {currencyCode}
                                {currencySymbol + (line_item_price * item.quantity).toFixed(
                                    0,
                                )}
                              </p>
                            </div>
                        )}
                      </div>
                    </div>
                  </div> */}
                </div>

                <div
                  className="flex errors b4 my-0"
                  style={{ padding: 0 }}
                  data-ajax-cart-errors={`${item.key}`}
                ></div>
                </div>
              </div>

              {/* {size && (
                <div className={"brs mt-1"}>{size?.value}</div>
              )} */}

          
            </div>
            <div className={`product-details__inner-info px-2`}>
                <div className={'discounts_applied'}>
                  {item.discounts.map((discount, id) => {
                    return (
                        <React.Fragment key={id}>
                          <p className={"brs text-[#394E47]"}>
                            {discount.title}</p>
                        </React.Fragment>
                    );
                  })}
                </div>
              </div>
          </div>
        </div>
      </div>
    </>
  );
};
